import { Button, Col, Form, Input, Modal, Row, Switch,  } from "antd";
import Variacio from "../../../model/menudesign/Variacio";
import { BiCheck, BiX } from "react-icons/bi";
import Colors from "../../../styles/Colors";
import { PostVariants } from "../../../dao/menudesign/PostVariants";

const { TextArea } = Input;
interface IngredientModalProps {
    element: Variacio;
    visible: boolean;
    page: string;
    editar?: boolean;
    onClose: (value: boolean) => void;
}

const VariacioModal: React.FC<IngredientModalProps> = ({element, visible, page, editar, onClose}) => {
    const [form] = Form.useForm();
    async function handleSubmit() {
        const id = await form.getFieldValue('id');
        const nom = await form.getFieldValue('nom');
        const comentaris = await form.getFieldValue('comentaris');
        const estat = await form.getFieldValue('estat');
        await PostVariants(id,nom,comentaris,estat,page);
        await onClose(true);
    };
    async function handleCancel() {
        await onClose(false);
    };
    return (
        <Modal
            title="Crear/Editar Variants"
            open={visible}
            onCancel={handleCancel}
            footer={[ 
            ]}
            width={"40%"}
        >
            <Form form={form} initialValues={element} onFinish={handleSubmit}>
                
                    <Form.Item label="ID" name="id">
                        <Input disabled/>
                    </Form.Item>
                    <Form.Item label="Nom" name="nom">
                        <Input type="text"/>
                    </Form.Item>
                    <Form.Item label="Comentaris" name="comentaris">
                        <TextArea rows={4} />
                    </Form.Item>
                    
                <hr/>
                <Row gutter={[16, 16]}>
                    <Col span={1}>
                        <Form.Item wrapperCol={{offset: 0, span: 16}}>
                            <Button title={"Aceptar"} htmlType={"submit"}
                                    style={{backgroundColor: Colors.colors.color6}}><BiCheck/></Button>
                        </Form.Item>
                    </Col>
                    <Col span={1}>
                    </Col>
                    <Col span={1}>
                        <Button title={"Cancelar"} style={{backgroundColor: Colors.colors.color1}}
                                onClick={handleCancel}><BiX/></Button>
                    </Col>
                </Row>
            </Form>
        </Modal>
    );
};
export default VariacioModal;